import type { ThreadMessage } from "@tellescope/tanstack-query";

export const selectThreadDraft = (
  drafts: ThreadMessage[],
  currentUserId: string | undefined
): ThreadMessage | undefined => {
  const mostRecent = (a: ThreadMessage | undefined, b: ThreadMessage) =>
    !a || b.timestamp.getTime() >= a.timestamp.getTime() ? b : a;

  const { own, other } = drafts.reduce<{ own?: ThreadMessage; other?: ThreadMessage }>((acc, draft) => {
    if (currentUserId && draft.sender?.id === currentUserId) {
      acc.own = mostRecent(acc.own, draft);
    } else {
      acc.other = mostRecent(acc.other, draft);
    }
    return acc;
  }, {});

  return own ?? other;
};
